export const HUB_FOLDERS_REQUEST = "HUB_FOLDERS_REQUEST";
export const HUB_FOLDERS_SUCCESS = "HUB_FOLDERS_SUCCESS";
export const HUB_FOLDERS_FAIL = "HUB_FOLDERS_FAIL";

export const HUB_CREATE_FOLDER_REQUEST = "HUB_CREATE_FOLDER_REQUEST";
export const HUB_CREATE_FOLDER_SUCCESS = "HUB_CREATE_FOLDER_SUCCESS";
export const HUB_CREATE_FOLDER_FAIL = "HUB_CREATE_FOLDER_FAIL";

export const HUB_RENAME_FOLDER_SUCCESS = "HUB_RENAME_FOLDER_SUCCESS";
export const HUB_DELETE_FOLDER_SUCCESS = "HUB_DELETE_FOLDER_SUCCESS";

export const HUB_FILES_REQUEST = "HUB_FILES_REQUEST";
export const HUB_FILES_SUCCESS = "HUB_FILES_SUCCESS";
export const HUB_FILES_FAIL = "HUB_FILES_FAIL";

export const HUB_UPLOAD_REQUEST = "HUB_UPLOAD_REQUEST";
export const HUB_UPLOAD_SUCCESS = "HUB_UPLOAD_SUCCESS";
export const HUB_UPLOAD_FAIL = "HUB_UPLOAD_FAIL";

export const HUB_DELETE_FILE_SUCCESS = "HUB_DELETE_FILE_SUCCESS";

export const HUB_VIEW_URL_REQUEST = "HUB_VIEW_URL_REQUEST";
export const HUB_VIEW_URL_SUCCESS = "HUB_VIEW_URL_SUCCESS";
export const HUB_VIEW_URL_FAIL = "HUB_VIEW_URL_FAIL";
export const HUB_CLEAR_VIEW_URL = "HUB_CLEAR_VIEW_URL";

export const HUB_SET_NAVIGATION = "HUB_SET_NAVIGATION";
export const HUB_RESET = "HUB_RESET";

// Tenant-only virtual categories under the General root.
export const HUB_SET_TENANT_CATEGORY = "HUB_SET_TENANT_CATEGORY";

export const HUB_SHARED_PROPERTY_REQUEST = "HUB_SHARED_PROPERTY_REQUEST";
export const HUB_SHARED_PROPERTY_SUCCESS = "HUB_SHARED_PROPERTY_SUCCESS";
export const HUB_SHARED_PROPERTY_FAIL = "HUB_SHARED_PROPERTY_FAIL";

export const HUB_SHARED_COMPLIANCE_REQUEST = "HUB_SHARED_COMPLIANCE_REQUEST";
export const HUB_SHARED_COMPLIANCE_SUCCESS = "HUB_SHARED_COMPLIANCE_SUCCESS";
export const HUB_SHARED_COMPLIANCE_FAIL = "HUB_SHARED_COMPLIANCE_FAIL";
